import { BasicRequest } from "./basicRequest";

export class AuthConsumerPostParameter extends BasicRequest {
    public ConsumerPhone?: string;
    public PIN?: string;
}